import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import CopyIcon from '@opsbase/web-icons/icons/CopyIcon';
import DeleteIcon from '@opsbase/web-icons/icons/DeleteIcon';
import EditIcon from '@opsbase/web-icons/icons/EditIcon';
import PreviewIcon from '@opsbase/web-icons/icons/PreviewIcon';
import PublishIcon from '@opsbase/web-icons/icons/PublishIcon';
import StaffIcon from '@opsbase/web-icons/icons/StaffIcon';
import UndoIcon from '@opsbase/web-icons/icons/UndoIcon';
import useNav from '@opsbase/web-nav/useNav';
import React, { useCallback } from 'react';
import ItemMenu from './ItemMenu';
export const OpDefinitionMenu = React.memo((props) => {
    const { item, ...otherProps } = props;
    const self = useSelf();
    const { goTo, openTo } = useNav();
    const handleAssignOp = useCallback(() => {
        goTo(Pages.OP_DEFINITIONS_ASSIGN, undefined, { opDefinition: item });
    }, [goTo, item]);
    const handlePreview = useCallback(() => {
        openTo(Pages.OP_PREVIEW, { id: item.id });
    }, [openTo, item]);
    if (!item)
        return null;
    const isPrimary = self.isPrimary || self.isSuperUser;
    const isLocked = (!isPrimary && item.lockEditingToPrimaryAdmins) || item.lockEditing;
    const isFullyOwned = self.accessiblePlaces.includesAll(item.places.map(s => s.id));
    const isPublishRequired = !!item.requiresPublishing;
    return (React.createElement(ItemMenu, { id: item.id, options: [
            {
                icon: EditIcon,
                label: i18n.t('edit'),
                page: Pages.OP_DEFINITIONS_EDIT,
                variant: 'action',
            },
            {
                icon: PublishIcon,
                label: i18n.t('publish'),
                page: Pages.OP_DEFINITIONS_PUBLISH,
                variant: 'good',
                visible: isPrimary && isPublishRequired,
            },
            {
                icon: UndoIcon,
                label: i18n.t('revert'),
                page: Pages.OP_DEFINITIONS_REVERT,
                variant: 'warn',
                visible: isPrimary && isPublishRequired,
            },
            {
                icon: PreviewIcon,
                label: i18n.t('preview'),
                onClick: handlePreview,
                variant: 'action',
            },
            {
                icon: StaffIcon,
                label: i18n.t('assign'),
                onClick: handleAssignOp,
                variant: 'good',
            },
            {
                icon: CopyIcon,
                label: i18n.t('copy'),
                page: Pages.OP_DEFINITIONS_COPY,
                variant: 'action',
                visible: isPrimary,
            },
            {
                icon: DeleteIcon,
                label: i18n.t('delete'),
                page: Pages.OP_DEFINITIONS_DELETE,
                variant: 'warn',
                visible: isPrimary || (!isLocked && isFullyOwned),
            },
        ], ...otherProps }));
});
export default OpDefinitionMenu;
